/**
 * The two business packages and how an owner can pay for Premium.
 *
 * Payment handles: fill these in and they appear in the upgrade screen; while
 * they're empty the owner still submits the request and the site team replies
 * with the details, then activates the plan from the admin panel.
 */
export const PAYMENT_HANDLES = {
  athMovil: "",
  paypal: "",
};

export const PREMIUM_PRICES = {
  monthly: 19,
  yearly: 149,
};

export const BASIC_FEATURES = [
  "Your hours, phone, address and website kept current",
  "One photo and a description you write yourself",
  "Listed as managed by its owner",
];

export const PREMIUM_FEATURES = [
  "Everything in Basic",
  "Verified badge on your card, your page and your map pin",
  "Instagram, Facebook, TikTok, X, YouTube and WhatsApp links",
  "Full photo gallery — up to six images",
  "Book, Order or Reserve button on your page",
];

/**
 * What an experience pays: a set monthly fee, or a commission on the bookings
 * it takes through its own system — the rate comes from the operator's own
 * partner terms and is agreed with the site team.
 */
export const money = (n) => `$${n}`;

export const EXPERIENCE_PRICING = {
  monthly: 99,
};

/** What someone is adding to the guide, on the for-business page. */
export const BUSINESS_KINDS = [
  { value: "Restaurant / bar / café", key: "join.kindFood" },
  { value: "Shop or boutique", key: "join.kindShop" },
  { value: "Hotel / guesthouse", key: "join.kindStay" },
  { value: "Local service", key: "join.kindService" },
  { value: "Experience or tour", key: "join.kindExperience" },
  { value: "Something else", key: "join.kindOther" },
];

/** How they want to join; the value is the line the site team reads. */
export const JOIN_PLANS = [
  { value: "Freemium — free listing", key: "join.planFree" },
  { value: "Subscription — monthly paid plan", key: "join.planSubscription" },
  {
    value: `Experience — ${money(EXPERIENCE_PRICING.monthly)} a month flat`,
    key: "join.planExpFlat",
    params: { price: money(EXPERIENCE_PRICING.monthly) },
  },
  { value: "Experience — commission on bookings", key: "join.planExpCommission" },
];

/** Premium is live only while its paid period lasts. */
export const isPremium = (listing) =>
  listing?.plan === "Premium" && (!listing.plan_until || new Date(listing.plan_until).getTime() > Date.now());